export default function (value, maxLength = 100) {
    let result = '';
    let words = value.split(/\s/);

    do {
        result = `${result} ${words.shift()}`;
    } while (words.length && `${result} ${words[0]}`.length < maxLength);
    let resultArr = result.replace(/^[,\s]+|[,\s]+$/, '').split(/\s/);
    let valueArr = value.replace(/^[,\s]+|[,\s]+$/, '').split(/\s/);

    if (resultArr.length !== valueArr.length) {
        result = result.replace(/\s(для|при|по|на|из|и|в|с|к)$/gi, '').replace(/^[,\s]+|[,\s]+$/, '');
    }
    return result.length < value.length ? `${result}...` : result;
}
